import { eventsKeysCompare } from './checkutils';

export const isWebGa = () => {
  return localStorage.getItem('GV_NETWORK_PLATFORM_TYPE') === 'WEB';
};

const isWeb = isWebGa();

export const isMPEvent = (url) => {
  return url.includes('mp/collect');
};

export const isGVEvent = (url) => {
  return url.includes('/records');
};
export const getEventName = (events) => {
  const { gv, ga } = events;

  let name = 'NA';
  if (gv) {
    name = gv.event_name;
  } else if (ga && !isWeb) {
    name = ga?.events[0]?.name;
  } else if (ga && isWeb) {
    name = ga.event;
  }
  return name;
};
export const getEventCDs = (events) => {
  const { gv, ga } = events;

  let gvEventData = gv?.event_data;
  let gaCd = null;

  if (isWeb) {
    if (gvEventData) {
      gaCd = {};
      for (let key in gvEventData) {
        gaCd[key] = ga[key];
      }
    }
  } else {
    //mp
    gaCd = ga?.events[0]?.params;
  }

  return {
    gvEventData,
    gaCd,
  };
};

export const getEventTopParams = (events) => {
  const { ga, gv } = events;

  let gaTopParams = null;

  if (isWeb) {
    if (gv) {
      gaTopParams = {};
      for (let key in gv) {
        gaTopParams[key] = ga[key];
      }
    } else {
      gaTopParams = ga;
    }
  } else {
    //mp
    gaTopParams = ga?.events[0];
  }

  const gvTopData = gv;

  return {
    gvTopData,
    gaTopParams,
  };
};

export const getEventUPs = (events) => {
  const { gv, ga } = events;
  let gvContext = gv?.context;
  let gvEventData = gv?.event_data;
  let gaUPs = null;
  if (isWeb) {
    if (gvContext) {
      gaUPs = {};
      for (let key in gvContext) {
        gaUPs[key] = ga[key];
      }
    }
    if (gvEventData && gvContext && ga) {
      for (let gaKey in ga) {
        if (
          gvEventData[gaKey] === undefined &&
          gvContext[gaKey] === undefined &&
          gv[gaKey] === undefined
        ) {
          gaUPs[gaKey] = ga[gaKey];
        }
      }
    }
  } else {
    //mp
    gaUPs = ga?.user_properties;
  }
  return {
    gvContext,
    gaUPs,
  };
};
export const getEventTime = (events) => {
  const { gv_timestamp, ga_timestamp } = events;

  let gv_time = 'pending';
  let ga_time = 'pending';
  if (gv_timestamp) {
    gv_time = new Date(gv_timestamp).toLocaleTimeString();
  }
  if (ga_timestamp) {
    ga_time = new Date(ga_timestamp).toLocaleTimeString();
  }
  return {
    gv_time,
    ga_time,
  };
};

export const isValidationDashboard = () => {
  let domainUrl =
    window?.location != window?.parent?.location
      ? document.referrer
      : document.location.href;
  if (domainUrl == '' || typeof domainUrl == 'undefined') {
    return false;
  }
  if (domainUrl.indexOf('tataplaybinge.com') != -1) {
    return false;
  }
  let isDash = !!~window.parent.location.href.indexOf('dashboard/index.html');
  return isDash;
};

export const removeLoader = () => {
  let loader = document.getElementById('validation_loader');
  if (loader) loader.remove();
};

export const compareData = (data) => {
  const { gv, ga } = data;

  let eventStats = {
    isUPPaased: false, //user properties
    isCDDataPassed: false, // custom dimensions
    isTopParamsPassed: false,
  };

  if (!gv || !ga) {
    return eventStats;
  }
  let isTopAllSame = true;

  let { gaTopParams, gvTopData } = getEventTopParams(data);
  let allKeys = new Set([
    ...Object.keys(gvTopData || {}),
    ...Object.keys(gaTopParams || {}),
  ]);
  for (let key of allKeys) {
    let v1 = gvTopData[key];
    let v2 = gaTopParams[key];

    if (typeof v1 !== 'object' && typeof v2 !== 'object') {
      const isEventsKeysCheck = eventsKeysCompare(data, key);
      if (!isEventsKeysCheck) {
        isTopAllSame = false;
        break;
      }
    }
  }
  eventStats.isTopParamsPassed = isTopAllSame;

  const { gvEventData: gvCD, gaCd: gaCD } = getEventCDs(data);
  if (gaCD && gvCD) {
    let isCDAllSame = true;
    let cdAllKeys = new Set([
      ...Object.keys(gaCD || {}),
      ...Object.keys(gvCD || {}),
    ]);
    for (let cd_key of cdAllKeys) {
      const isEventsKeysCheck = eventsKeysCompare(data, cd_key);
      let v1 = gaCD[cd_key];
      let v2 = gvCD[cd_key];

      if (!isEventsKeysCheck) {
        if (v1 !== undefined && v2 !== undefined) {
          if (typeof v1 === 'object' && isJson(v2)) {
            if (JSON.stringify(v1) !== v2) {
              isCDAllSame = false;
              break;
            }
          } else if (v1 != v2) {
            isCDAllSame = false;
            break;
          }
        } else {
          isCDAllSame = false;
          break;
        }
      }
    }
    eventStats.isCDDataPassed = isCDAllSame;
  }

  //user properties
  const { gaUPs: gaUP, gvContext: gvUP } = getEventUPs(data);

  if (gaUP && gvUP) {
    let isUPAllSame = true;
    let up_AllKeys = new Set([
      ...Object.keys(gaUP || {}),
      ...Object.keys(gvUP || {}),
    ]);
    for (let up_Key of up_AllKeys) {
      const isEventsKeysCheck = eventsKeysCompare(data, up_Key);
      if (!isEventsKeysCheck) {
        if (gaUP[up_Key]?.value != gvUP[up_Key]) {
          isUPAllSame = false;
          break;
        }
      }
    }
    eventStats.isUPPaased = isUPAllSame;
  }

  return eventStats;
};

export const getEventsData = () => {
  let gvData, gaData;

  gvData =
    typeof window.getGVNetworkLogs === 'function' && window.getGVNetworkLogs();
  if (!gvData) {
    gvData = JSON.parse(localStorage.getItem('GODAVARI_DATA'));
  }
  gaData =
    typeof window.getGANetworkLogs === 'function' && window.getGANetworkLogs();

  if (!gaData) {
    gaData = JSON.parse(localStorage.getItem('GODAVARI_GA_DATA'));
  }

  return {
    gvData,
    gaData,
  };
};

export const captureTableImage = (tableId) => {
  try {
    const tableElement = document.getElementById(tableId);
    if (!tableElement) {
      console.error('Table not found');
      return;
    }

    if (!window.domtoimage) return;
    window.domtoimage.toBlob(tableElement).then(function (blob) {
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, '_blank');
      navigator.clipboard
        .write([
          new ClipboardItem({
            [blob.type]: blob,
          }),
        ])
        .then(() => {
          console.log('Copied');
        })
        .catch((e) => {
          console.error('Error while copy', e);
        });
    });
  } catch (e) {
    console.error('Error while generating image', e);
  }
};
function isJson(item) {
  let value = typeof item !== 'string' ? JSON.stringify(item) : item;
  try {
    value = JSON.parse(value);
  } catch (e) {
    console.info(e);
    return false;
  }

  return typeof value === 'object' && value !== null;
}
